import {Button, Stack, TextField, Typography} from "@mui/material";
import TinyEditor from "../../components/TinyEditor";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import {useContext, useState} from "react";
import ApartmentContext from "../../context/ApartmentContext";
import ConfigContext from "../../context/ConfigContext";

const PopupData = ({obj, reference}) => {
    const [image, setImage] = useState(obj?.image || '')
    const {baseUrl} = useContext(ConfigContext)

    const getPic = () => {
        if (image instanceof File) return URL.createObjectURL(image)
        if (image?.startsWith('http')) return image
        if (image) return baseUrl + image;
        else return ''
    }

    return <form ref={reference}>
        <Stack spacing={2}>
            <Typography variant='caption'>Cím</Typography>
            <TextField variant='standard' id="title" name="title" defaultValue={obj?.title || ''}/>

            <Typography variant='caption'>Szöveg</Typography>
            <TinyEditor name='content' initialValue={obj?.content || ''}/>

            <Typography variant='caption'>Kép</Typography>
            <img src={getPic(image)} style={{width: '30%', borderRadius: 10}}/>
            <Button sx={{padding: '16px'}} component='label' variant='outlined'
                    endIcon={<FileUploadRoundedIcon/>}>Kép feltöltése
                <input type="file"
                       onChange={event => setImage(event.target.files[0])}
                       hidden
                       name='image'
                       id='image'
                       accept='image/*'/>
            </Button>
        </Stack>

    </form>
}

export default PopupData;